import { ProfileUserState } from '../states/profile-user.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
  followUnFollowSuccessAction,
  loadMeAsProfileUser,
  loadProfileUser,
  loadProfileUserError,
  loadProfileUserSuccess,
  removeProfileCoverImage,
  removeProfileCoverImageError,
  removeProfileCoverImageSuccess,
  removeProfileImage,
  removeProfileImageError,
  removeProfileImageSuccess,
  updateProfile,
  updateProfileError,
  updateProfileSuccess,
  uploadProfileCoverImage,
  uploadProfileCoverImageError,
  uploadProfileCoverImageSuccess,
  uploadProfileImage,
  uploadProfileImageError,
  uploadProfileImageSuccess
} from '../actions/profile-user.actions';
import { initialProfileImageState } from '../states/profile-image.state';

export const initialState: ProfileUserState = {
  error: '',
  loading: false,
  profileUser: null,
  coverImage: null,
  profileImage: null,

  profileError: '',
  profileLoading: false
};

const reducer = createReducer(
  initialState,

  on(loadMeAsProfileUser, state => ({
    ...state,
    error: '',
    loading: true
  })),

  on(loadProfileUser, state => ({
    ...state,
    error: '',
    loading: true
  })),

  on(loadProfileUserSuccess, (state, { profileUser }) => ({
    ...state,
    profileUser: profileUser,
    profileImage: {
      ...initialProfileImageState,
      path: profileUser?.profileData?.photoURL || ''
    },
    coverImage: {
      ...initialProfileImageState,
      path: profileUser?.profileData?.coverPhoto || ''
    },
    loading: false,
    error: ''
  })),

  on(loadProfileUserError, (state, { error }) => ({
    ...state,
    error: error,
    loading: false
  })),

  on(updateProfile, state => ({
    ...state,
    profileError: '',
    profileLoading: true
  })),

  on(updateProfileSuccess, (state, { payload }) => ({
    ...state,
    profileError: '',
    profileLoading: false,
    profileUser: payload
  })),

  on(updateProfileError, (state, { payload }) => ({
    ...state,
    profileError: payload,
    profileLoading: false
  })),

  on(followUnFollowSuccessAction, (state, { modifiedUser }) => ({
    ...state,
    profileUser: modifiedUser
  })),

  // image upload
  on(uploadProfileImage, (state, { payload }) => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      path: payload.path,
      error: '',
      loading: true
    }
  })),

  on(uploadProfileImageSuccess, state => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      loading: false,
      error: ''
    }
  })),

  on(uploadProfileImageError, (state, { error }) => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      path: '',
      loading: false,
      error
    }
  })),

  on(uploadProfileCoverImage, (state, { payload }) => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      path: payload.path,
      error: '',
      loading: true
    }
  })),

  on(uploadProfileCoverImageSuccess, state => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      error: '',
      loading: false
    }
  })),

  on(uploadProfileCoverImageError, (state, { error }) => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      path: '',
      loading: false,
      error
    }
  })),

  on(removeProfileImage, state => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      loading: true,
      error: ''
    }
  })),

  on(removeProfileImageSuccess, state => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      loading: false,
      path: ''
    }
  })),

  on(removeProfileImageError, (state, { error }) => ({
    ...state,
    profileImage: {
      ...state.profileImage,
      loading: false,
      error
    }
  })),

  on(removeProfileCoverImage, state => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      loading: true,
      error: ''
    }
  })),

  on(removeProfileCoverImageSuccess, state => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      path: '',
      loading: false
    }
  })),

  on(removeProfileCoverImageError, (state, { error }) => ({
    ...state,
    coverImage: {
      ...state.coverImage,
      loading: false,
      error
    }
  }))
);

export function profileUserReducer(
  state: ProfileUserState | undefined,
  action: Action
): ProfileUserState {
  return reducer(state, action);
}
